





































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ComponentsIconButton extends Vue {
  private vactive = false;

  private fclick(e: MouseEvent): void {
    alert(e);
  }
}
